import cx from 'classnames';

import { BaseButtonType } from 'components/base-button';
import ButtonLoader from 'components/button-loader';
import { Link } from 'components/router';
import { Text } from 'components/typography';

type IconCTAProps = {
  link?: string;
  icon: React.ReactNode;
  text: string;
  ariaText?: string;
  onClick?: (event?: React.SyntheticEvent<EventTarget>) => void;
  className?: string;
  isLoading?: boolean;
  type?: BaseButtonType;
  disabled?: boolean;
};

type ItemComponentProps = {
  href?: string;
  type?: string;
  onClick?: (e: React.SyntheticEvent<EventTarget>) => void;
};

const IconCTA = ({
  link,
  icon,
  text,
  ariaText,
  onClick,
  className,
  isLoading = false,
  type = BaseButtonType.Primary,
  disabled
}: IconCTAProps): React.ReactNode => {
  // If link prop is present then the ItemComponent will be rendered as Link
  // otherwise it'll be rendered as button,

  let ItemComponent;
  const itemProps: ItemComponentProps = {};

  if (!link) {
    ItemComponent = 'button';
    itemProps.type = 'button';
  } else {
    ItemComponent = Link;
  }

  if (link) {
    itemProps.href = link;
  }
  if (onClick) {
    itemProps.onClick = (e: React.SyntheticEvent<EventTarget>) => onClick(e);
  }

  const iconClasses = cx('transition-opacity duration-300', {
    'opacity-100': !isLoading,
    'opacity-0': isLoading
  });

  return (
    <ItemComponent
      {...(!link && { disabled: disabled || isLoading })}
      {...itemProps}
      onClick={(e: React.SyntheticEvent<EventTarget>) => onClick && onClick(e)}
      className={cx(
        'flex w-max items-center transition-colors duration-300 hover:text-gray-900 disabled:cursor-not-allowed disabled:text-black',
        className
      )}
      aria-label={ariaText || text}
    >
      <div className="relative">
        {isLoading && (
          <div className="absolute left-0 top-0 flex size-full items-center justify-center transition-opacity">
            <ButtonLoader type={type} />
          </div>
        )}
        <div className={iconClasses}>{icon}</div>
      </div>
      <Text size="l" className="ml-3">
        {text}
      </Text>
    </ItemComponent>
  );
};

export default IconCTA;
